/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useEffect, useMemo, useState, useCallback } from 'react';
import CustomTable from 'components/cmn/CustomTable';
import { DiagnosticHistoryTableHead } from 'components/cmn/CustomTableHeadWrapper';
import { useProject } from 'hooks/useProject';
import { SurveyListLatestContent } from 'interface/project/projectInfo';
import DiagnosticHistoryTableBody from './DiagnosticHistoryTableBody';

function DiagnosticHistoryTable({ id }: { id: string }): JSX.Element {
  const [allLoading, setAllLoading] = useState(true);

  const { getInfiniteSurveyListByName } = useProject();
  const { data: surveyData, size, setSize, isReachingEnd, isLoadingMore } = getInfiniteSurveyListByName(id || '');

  const surveys: SurveyListLatestContent[] = useMemo(() => {
    return surveyData?.map(surveyListInfo => surveyListInfo.contents).reduce((pre, cur) => pre.concat(cur)) || [];
  }, [surveyData]);

  const loadMore = useCallback(() => {
    setSize(size + 1);
  }, [setSize, size]);

  useEffect(() => {
    if (id.length > 0 && allLoading && !isLoadingMore) {
      if (!isReachingEnd) {
        loadMore();
      } else {
        setAllLoading(false);
      }
    }
  }, [allLoading, id.length, isLoadingMore, isReachingEnd, loadMore]);

  return (
    <CustomTable maxHeight="calc(40vh)" isPagination={false}>
      <DiagnosticHistoryTableHead order="desc" orderBy="id" />
      <DiagnosticHistoryTableBody loading={allLoading} rows={surveys} duration={0} />
    </CustomTable>
  );
}

export default memo(DiagnosticHistoryTable);
